export const ReadOnlyPrice = ({ price = "" }) => {
    let decimals = "";
    price = price.toString();
    const formatPrice = price => {
        if (price.length <= 3) return price;
        else
            return (
                formatPrice(price.slice(0, -3)) +
                "," +
                price.slice(-3)
            );
    };
    if(price.indexOf(".") >= 0){   
        decimals = price.slice(-3);
        price = price.slice(0, -3);
        return " $" + formatPrice(price) + decimals;
    }
    else{
        return " $" + formatPrice(price)
    }
};



// WEBPACK FOOTER //
// ./src/components/atomic/atoms/ReadOnlyPrice/ReadOnlyPrice.js